/**
 * Locale-aware country labels via `Intl.DisplayNames`.
 * Cached per locale (same pattern as widget flows).
 */

const displayNamesCache = new Map<string, Intl.DisplayNames>();

const getDisplayNames = (locale: string): Intl.DisplayNames => {
  let dn = displayNamesCache.get(locale);
  if (!dn) {
    dn = new Intl.DisplayNames([locale], { type: "region" });
    displayNamesCache.set(locale, dn);
  }
  return dn;
};

export const countryDisplayName = (
  code: string | undefined | null,
  locale = "en"
): string => {
  if (!code) return "";
  const upper = code.toUpperCase();
  try {
    return getDisplayNames(locale).of(upper) ?? upper;
  } catch {
    return upper;
  }
};
